import { CONTENT_PLATFORM_PROPERTY_NAME } from 'content-management-data-lib';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PAGE_PROPERTY_NAMES } from 'page-lib/constants/propertyNames';
import { getContentDynamicPageHubDbTableId } from '../utils/dynamicPageUtils';
import PageUrl from '../components/PageUrl';
import { Link } from 'foundations-components/transitional/components/Link';
import useFetchStylesheets from '../hooks/useFetchStylesheets';
import useContentId from '../hooks/useContentId';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import ContentRoutes from 'ContentUtils/Routes';
import DesignAssetTypes from 'ContentUtils/constants/DesignAssetTypes';
import { HubDbRowName, HubDbRowPath } from '../components/HubDbDetailComponents';
import { HubDbTable } from '../components/HubDbDetailComponents';
import { jsx as _jsx } from "react/jsx-runtime";
const makeStylesheetDescription = stylesheets => {
  return () => /*#__PURE__*/_jsx(List, {
    children: stylesheets.map(stylesheet => {
      const assetId = stylesheet.id;
      return /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Link, {
          external: true,
          href: ContentRoutes.designManager(assetId, DesignAssetTypes.TEMPLATE),
          children: stylesheet.path
        })
      }, assetId);
    })
  });
};
const DETAILS_PANEL_CONFIG_OVERRIDES = {
  [CONTENT_PLATFORM_PROPERTY_NAME.ABSOLUTE_URL]: {
    Description: PageUrl
  },
  [PAGE_PROPERTY_NAMES.DYNAMIC_PAGE_DATA_SOURCE_ID]: {
    Title: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "page-details-ui.header.titles.hs_dynamic_page_data_source_id"
    }),
    Description: HubDbTable,
    hidden: contentCrmObject => {
      const dynamicPageHubDbTableId = getContentDynamicPageHubDbTableId(contentCrmObject);
      return !dynamicPageHubDbTableId;
    }
  },
  hubDbRowName: {
    Title: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "page-details-ui.header.titles.hubDbRowName"
    }),
    Description: HubDbRowName,
    hidden: contentCrmObject => {
      const dynamicPageHubDbTableId = getContentDynamicPageHubDbTableId(contentCrmObject);
      return !dynamicPageHubDbTableId;
    }
  },
  hubDbRowPath: {
    Title: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "page-details-ui.header.titles.hubDbRowPath"
    }),
    Description: HubDbRowPath,
    hidden: contentCrmObject => {
      const dynamicPageHubDbTableId = getContentDynamicPageHubDbTableId(contentCrmObject);
      return !dynamicPageHubDbTableId;
    }
  }
};
export const useGetDetailsPanelConfigOverrides = () => {
  const finalConfig = Object.assign({}, DETAILS_PANEL_CONFIG_OVERRIDES);
  const contentId = useContentId();
  const {
    stylesheets
  } = useFetchStylesheets(contentId);
  if (stylesheets) {
    const stylesheetPrimary = stylesheets.default_custom_css_path;
    const stylesheetsDomain = stylesheets.domain_attached_stylesheets;
    const stylesheetsLayout = stylesheets.layout_attached_stylesheets;
    const stylesheetsPage = stylesheets.page_attached_stylesheets;
    if (stylesheetPrimary) {
      finalConfig.stylesheetPrimary = {
        Title: () => /*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.header.titles.stylesheets.primary"
        }),
        Description: () => {
          const href = `${ContentRoutes.designManager()}?templatePath=${stylesheetPrimary}`;
          return /*#__PURE__*/_jsx(Link, {
            href: href,
            external: true,
            children: href
          });
        }
      };
    }
    if (stylesheetsDomain && stylesheetsDomain.length > 0) {
      finalConfig.stylesheetsDomain = {
        Title: () => /*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.header.titles.stylesheets.domain"
        }),
        Description: makeStylesheetDescription(stylesheetsDomain)
      };
    }
    if (stylesheetsLayout && stylesheetsLayout.length > 0) {
      finalConfig.stylesheetsLayout = {
        Title: () => /*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.header.titles.stylesheets.template"
        }),
        Description: makeStylesheetDescription(stylesheetsLayout)
      };
    }
    if (stylesheetsPage && stylesheetsPage.length > 0) {
      finalConfig.stylesheetsPage = {
        Title: () => /*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.header.titles.stylesheets.page"
        }),
        Description: makeStylesheetDescription(stylesheetsPage)
      };
    }
  }
  return finalConfig;
};